import { Dispatch } from 'redux'
import {
  add as addAction,
  set as setAction,
  setLoading,
  update as updateAction
} from 'states/dux/amenity-booking/actions'
import { Payload } from 'states/dux/amenity-booking/types'
import { Action } from 'states/types'
import { AmenityBooking } from 'types/amenity-booking'

type DispatchAction = (dispatch: Dispatch) => Action<Payload>

const set = (amenityBookings: AmenityBooking[]): DispatchAction => {
  return (dispatch: Dispatch): Action<Payload> =>
    dispatch(
      setAction({
        loading: false,
        data: amenityBookings
      })
    )
}

const add = (amenityBooking: AmenityBooking): DispatchAction => {
  return (dispatch: Dispatch): Action<Payload> =>
    dispatch(
      addAction({
        loading: false,
        data: [amenityBooking]
      })
    )
}

const update = (amenityBooking: AmenityBooking): DispatchAction => {
  return (dispatch: Dispatch): Action<Payload> =>
    dispatch(
      updateAction({
        loading: false,
        data: [amenityBooking]
      })
    )
}

const loading = (loading = true): DispatchAction => {
  return (dispatch: Dispatch): Action<Payload> => dispatch(setLoading(loading))
}

export interface Operations {
  set: (amenityBookings: AmenityBooking[]) => DispatchAction
  add: (amenityBooking: AmenityBooking) => DispatchAction
  update: (amenityBooking: AmenityBooking) => DispatchAction
  loading: (loading: boolean) => DispatchAction
}

const operations: Operations = {
  set,
  add,
  update,
  loading
}

export { operations, set }
